module.exports = __webpack_public_path__ + "media/images/about-logo-rbff-20b676b24e1cda529f6f70b765b480ec.png";